const lightbox = document.getElementById('lightbox');
const lightboxImg = lightbox.querySelector('img');
const escapeBox = lightbox.querySelector('.close-lightbox');


//whenever a lightboxImg is clicked, open the lightbox
document.querySelectorAll('.lightImg').forEach(img => {

    img.addEventListener('click', () => {
        lightboxImg.src = img.src;
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden'; // stop scrolling
    
    });
});


// Close on click or ESC
function closeLightbox() {
lightbox.classList.remove('active');
document.body.style.overflow = '';
}

//Close lightbox triggers
lightbox.addEventListener('click', e => {
if (e.target === lightbox) closeLightbox();
});

document.addEventListener('keydown', e => {
if (e.key === 'Escape') closeLightbox();
});

lightbox.addEventListener('click', e => {
if (e.target === escapeBox) closeLightbox();
});